//
//
//
//
//
//

export default {
  name: "VocWatermark",
  props: {
    rotate: {
      type: Number,
      default: -20
    },
    text: {
      type: String,
      default: ""
    },
    fontStyle: {
      type: Object,
      default: () => ({
        size: 12,
        color: "#36404F",
        family: "sans-serif"
      })
    },
    opacity: {
      type: Number,
      default: 0.09
    },
    width: {
      type: [Number, String],
      default: "100%"
    },
    height: {
      type: [Number, String],
      default: "100%"
    }
  },
  data() {
    return {
      devicePxRatio: window.devicePixelRatio || 1,
      style: {}
    }
  },
  watch: {
    height(height) {
      this.style.height = height
      this.init()
    },
    text() {
      this.init()
    }
  },
  created() {
    this.style = Object.assign({}, this.style, {
      opacity: this.opacity,
      width: this.width,
      height: this.height,
      "pointer-events": "none"
    })
  },
  mounted() {
    if (this.text) {
      this.init()
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const canvas = this.$refs.canvas
        const ctx = canvas.getContext("2d")
        const parentWidth = this.$refs.wrapper.offsetWidth
        const parentHeight = this.$refs.wrapper.offsetHeight
        console.log(parentWidth, parentHeight)
        canvas.width = parentWidth * this.devicePxRatio
        canvas.height = parentHeight * this.devicePxRatio

        // 重复绘制,详细说明：https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/createPattern
        const pattern = ctx.createPattern(this.createSmallMark(), "repeat")
        ctx.fillStyle = pattern
        ctx.fillRect(0, 0, parentWidth * this.devicePxRatio, parentHeight * this.devicePxRatio)
      })
    },

    // 创建水印小图
    createSmallMark() {
      const fontSize = this.fontStyle.size * this.devicePxRatio
      const canvas = document.createElement("canvas")
      const ctx = canvas.getContext("2d")
      ctx.font = `${fontSize}px ${this.fontStyle.family}`
      const { width: textWidth } = ctx.measureText(this.text)
      const maxWidth = textWidth * 2

      // 获取文字宽度用于计算canvas宽高
      // 宽度 = 文字宽度 * 设备像素比，防止模糊
      canvas.width = this.devicePxRatio > 1 ? maxWidth : maxWidth * 2
      // 高度同宽度计算一样
      canvas.height = maxWidth
      canvas.style.width = `${maxWidth}px`
      canvas.style.height = `${maxWidth}px`

      ctx.font = `${fontSize}px ${this.fontStyle.family}`
      ctx.fillStyle = this.fontStyle.color
      ctx.rotate((this.rotate * Math.PI) / 180)

      if (this.rotate > 0) {
        ctx.translate(this.rotate / 2, 0)
        ctx.textAlign = "left"
        ctx.textBaseline = "top"
        ctx.fillText(this.text, 0, 0)
      } else {
        ctx.translate(this.rotate, 0)
        ctx.textAlign = "left"
        ctx.textBaseline = "bottom"
        ctx.fillText(this.text, fontSize, maxWidth)
      }
      return canvas
    }
  }
}
